export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.6.15-1446.01",
  commitId: "6691b7ab9c591543de3c7599b20c72bc56fd3f89",
  commitTime: "2026-06-15T14:46:01.000Z",
});
